import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Menu, MenuItem } from '@mui/material'
import { useHistory } from 'react-router-dom'
import EnvironmentFeature from 'utils-support/EnvironmentFeature'
import { SupportEnvironment } from 'core/enums/enums'
import { IRootReducerState } from 'state/reducers'
import { useSelector } from 'react-redux'

const UserMenu: React.FC<{}> = () => {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget), [setAnchorEl])
  const handleClose = useCallback(() => setAnchorEl(null), [setAnchorEl])

  const userName = useSelector((state: IRootReducerState) => `${state.auth.user.given_name} ${state.auth.user.family_name}`)
  const history = useHistory()
  const logout = useCallback(() => history.push('/auth/logout'), [history.push])
  const gotoAccountSettigns = useCallback(() => history.push('/account-settings'), [history.push])

  return (
    <>
      <Button sx={{ height: '100%' }} color='secondary' data-testid='header-dropdown-locales' onClick={handleClick}>
        {userName}
      </Button>
      <Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
        <MenuItem onClick={logout} data-testid='header-item-logout'>
          {t('global.menu_logout')}
        </MenuItem>
        <EnvironmentFeature environments={SupportEnvironment.Develop} ignoreSimulatedEnvironment>
          <MenuItem onClick={gotoAccountSettigns} data-testid='header-item-account-settings'>
            {t('global.account_settings')}
          </MenuItem>
        </EnvironmentFeature>
      </Menu>
    </>
  )
}

export default UserMenu
